import { useEffect } from "react";

import { GA_MEASUREMENT_ID, isProductionHost } from "../consts";

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

const SCRIPT_ID = "ga-gtag-js";

// Подключает стандартный сниппет Google Analytics (gtag.js); только прод и только
// если задан GA_MEASUREMENT_ID
export const useGoogleAnalytics = () => {
  useEffect(() => {
    if (!isProductionHost || !GA_MEASUREMENT_ID) {
      return;
    }

    if (document.getElementById(SCRIPT_ID)) {
      return;
    }

    const script = document.createElement("script");

    script.id = SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];

    function gtag(...args: unknown[]) {
      window.dataLayer?.push(args);
    }

    gtag("js", new Date());
    gtag("config", GA_MEASUREMENT_ID);
  }, []);
};
